import { render, staticRenderFns } from "./ConfigView.vue?vue&type=template&id=76e646b8&scoped=true"
import script from "./ConfigView.vue?vue&type=script&lang=js"
export * from "./ConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e646b8",
  null
  
)

export default component.exports